import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, mergeMap } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';

@Injectable({
  providedIn: 'root'
})
export class GeneraldataServiceTsService {

  idFascicoloTLF : string;
  importDatiSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private sectionsService: SectionsServiceTsService
  )  {

   }

  getGeneralData (idFascicoloPct) : Observable<any> {
    return this.http.get<any>(ServicePathsSettings.URL_GET_SECTIONS(idFascicoloPct, 'datiGenerali'));
  }

  importDatiGenerali(token, idFascicolo: string, sezione: string, giudice: string): Observable<any>{
    let req = {idFascicolo: idFascicolo, sezione: sezione, giudice: giudice};
    return this.http.post<any>(ServicePathsSettings.URL_IMPORT_DATI_GENERALI_PCT, req).pipe(
      mergeMap(() => this.sectionsService.updatePCT(token, idFascicolo, "datiGenerali"))
    )
  }

  onNextImportiDati(){
    this.importDatiSubject.next(null);
  }

}
